import { EventType } from "@/analytics/analytics-events";
import { IpxRegionOverLimitProperties } from "@/analytics/ipx-order-events-properties";
import { selectIpxEstimatedRegionBytes } from "@/store/modes/ipx-order-mode-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { FaroText, grey } from "@faro-lotv/flat-ui";
import { Analytics } from "@faro-lotv/foreign-observers";
import { Stack, useMediaQuery } from "@mui/material";
import { useEffect, useRef, type JSX } from "react";
import { IPX_MOCK_SIZE_LIMIT_BYTES } from "../ipx-config";
import { ScansPanel } from "./scans-step";

/** @returns the scan selection that defines the area with the region box */
export function DefineAreaPanel(): JSX.Element {
  const isTouch = useMediaQuery("(pointer: coarse)");
  useTrackRegionOverLimit();
  return (
    <Stack sx={{ gap: 2, flexGrow: 1 }}>
      <ScansPanel />
      {isTouch && (
        // The handles of the box react to the mouse only, see the lotv BoxControls
        <FaroText variant="bodyS" color={grey[600]}>
          To change the box, pinch and move the view to the area you need, then
          tap Auto-clip to fit the box to it.
        </FaroText>
      )}
    </Stack>
  );
}

/** Tracks when the selection grows over the size IPX accepts */
function useTrackRegionOverLimit(): void {
  const bytes = useAppSelector(selectIpxEstimatedRegionBytes);
  const isOverLimit = bytes !== undefined && bytes > IPX_MOCK_SIZE_LIMIT_BYTES;
  const wasOverLimit = useRef(false);
  useEffect(() => {
    if (isOverLimit && !wasOverLimit.current) {
      Analytics.track<IpxRegionOverLimitProperties>(
        EventType.ipxRegionOverLimit,
        { sizeBytes: bytes },
      );
    }
    wasOverLimit.current = isOverLimit;
  }, [bytes, isOverLimit]);
}
